import { Form, FormikProvider, useFormik } from "formik";
import React from "react";
import { z } from "zod";
import { validateFormikWithZodSchema } from "@helpers/form";
import { createFormikFields } from "@components/forms/fields/createFormikFields";
import { VStack } from "@design-system/VStack/VStack";
import { UpdateProfileFormProps } from "./types";

interface Value {
    phoneNumber: string;
}

const fields = createFormikFields<Value>();

const updatePhoneFormSchema = z.object({
    phoneNumber: z
        .string()
        .min(1, "Phone number is required")
        .regex(/\d{10}/, "Provide valid US phone number"),
});

export const UpdatePhoneForm: React.FC<UpdateProfileFormProps<Value>> = ({
    phoneNumber,
    onSubmit,
    children,
}) => {
    const formik = useFormik<Value>({
        initialValues: {
            phoneNumber,
        },
        validate: validateFormikWithZodSchema(updatePhoneFormSchema),
        onSubmit,
    });

    return (
        <FormikProvider value={formik}>
            <Form>
                <VStack gap={16}>
                    <fields.Phone
                        name="phoneNumber"
                        label="Phone number"
                        size="sm"
                    />
                    {children(formik.isValid)}
                </VStack>
            </Form>
        </FormikProvider>
    );
};
